import { useMutation } from '@tanstack/react-query';
import { downloadBlobByPath } from '../../../store/apis/commonService';

export default function useDownloadBlobByPath() {
  const downloadBlobByPathMutation = useMutation({
    mutationFn: payload => downloadBlobByPath(payload),
  });

  return {
    downloadBlobByPathMutation,
  };
}
